module.exports = __webpack_public_path__ + "static/media/hidden.703c0fa4.svg";